import React from 'react';
import IconLocationMarker from "@Icons/IconLocationMarker";
import {Colors} from "@Styles/Colors.style";

interface FormSuggestionProps {
    suggestion?: any,
    onClick?: () => void,
    onMouseDown?: () => void,
    onTouchStart?: () => void,
}

const FormSuggestion = ({suggestion, onClick, onMouseDown, onTouchStart}: FormSuggestionProps) => {
    const onClickHandler = (e: React.MouseEvent | React.TouchEvent) => {
        e.preventDefault()
        e.stopPropagation()
        if (onClick) {
            onClick()
        }
    }

    const handleMouseDown = (e: React.MouseEvent) => {
        // Mark that suggestion is being clicked (fires before blur)
        if (onMouseDown) {
            onMouseDown()
        }
        // Don't preventDefault - we want the click to fire
    }

    const handleTouchStart = (e: React.TouchEvent) => {
        // Mark that suggestion is being touched (fires before blur)
        if (onTouchStart) {
            onTouchStart()
        }
        // Don't preventDefault - we want the click to fire
    }

    return (
        <div
            role="button"
            onClick={onClickHandler}
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart}
            className="suggestion-content"
        >
            <IconLocationMarker
                style={{marginRight: '1rem'}}
                fill={Colors.primaryColor}
            />
            <span style={{width: "100%", display: "flex", justifyContent: "space-between"}}>
                <p>{suggestion.label}</p>
                <small>{suggestion?.country_name}</small>
            </span>
        </div>
    )
};

export default FormSuggestion;